import api from '../../api/api_resource'
import collect from 'collect.js'
import {getVuexState, saveVuexState} from "../../util/common";

const saveState = (state) => {
    saveVuexState('viewed_vehicles_state', state)
}

const state = getVuexState('viewed_vehicles_state', {
    ids: [],
    all: [],
    byVehicle: [],
    current_page: 1,
    per_page: 500,
    from: 1,
    to: 25,
    last_page: null,
    total: null,
    vehicleChecked: null,
    bidChecked: null,
    filteredUsers: null,
    includeCustomers: true,
    includeRep: true,
    repFilter: null,
    searchChassis: '',
    searchLot: '',
    dateOption: '',
    customDate: '',
    sortOrderBy: 'auction_date'
});
// getters
const getters = {
    all: state => state.all,
    ids: state => state.ids,
    getCurrentPage: state => state.current_page,
    getDateOption: state => state.dateOption,
    getCustomDate: state => state.customDate,
};

// actions
const actions = {
    getVehicleViews({ commit, state }, args) {
        return new Promise((success, error) => {
            console.log('getVehicleViews', args)
            args.sort_asc = args.sort_asc?1:0;
            const search_args = Object.assign({
                page: state.current_page,
                per_page: state.per_page
            }, args);
            api.index('vehicle-view', search_args).then(bidlist => {
                commit('setVehicleViews', bidlist);
                success(bidlist);
            }).catch(error => {
                console.log('error ' + error)
            });
        });
    },
};

// mutations
const mutations = {
    setVehicleViews (state, result) {
        let ids = [];
        if (result.data && result.data.length) {
            result.data.forEach(v => {
                ids.push(v.vehicle_id)
            })
        }
        state.all = result.data;
        state.ids = ids;
        state.total = result.total;
        state.last_page = result.last_page;
        state.from = result.from;
        state.to = result.to;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        saveState(state)
    },
    setFavouriteTags (state, result) {
        state.all = result;
        saveState(state)
    },
    updateVehicleViewMessages(state, {bid_id, message}) {
        state.all.forEach(vehicle => {
            if (vehicle && vehicle.bids) {
                vehicle.bids.forEach(bid => {
                    if (bid.id === bid_id) {
                        if (!bid.messages) {
                            bid.messages = [];
                        }
                        if (Array.isArray(message)) {
                            message.forEach((msg) => {
                                bid.messages.push(msg);
                            })
                        } else {
                            bid.messages.push(message);
                        }
                    }
                })
            }
        });
        saveState(state)
    },
    setVehicleChecked (state, checked) {
        state.vehicleChecked = checked
        saveState(state)
    },
    setVehicleViewChecked (state, checked) {
        state.bidChecked = checked
        saveState(state)
    },
    setFilteredUsers (state, filteredUsers) {
        state.filteredUsers = filteredUsers
        saveState(state)
    },
    setIncludeCustomers (state, includeCustomers) {
        state.includeCustomers = includeCustomers
        saveState(state)
    },
    setIncludeRep (state, includeRep) {
        state.includeRep = includeRep
        saveState(state)
    },
    setRepFilter (state, repFilter) {
        state.repFilter = repFilter
        saveState(state)
    },
    setSearchChassis (state, chassis) {
        state.searchChassis = chassis
        saveState(state)
    },
    setSearchLot (state, lot) {
        state.searchLot = lot
        saveState(state)
    },
    setDateOption (state, dateOption) {
        state.dateOption = dateOption
        saveState(state)
    },
    setCustomDate (state, date) {
        state.customDate = date
        saveState(state)
    },
    setSortOrderBy (state, orderBy) {
        state.sortOrderBy = orderBy
        saveState(state)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/vehicleViews.js